import { createIcon } from 'native-base';

export const MutedSpeakerIcon = () => {
  const CustomIcon = createIcon({
    viewBox: '0 0 256 256',
    path: [
      <g opacity="0.2">
        <path d="M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z" />
      </g>,
      <g>
        <path d="M224.544,71.44235a7.99983,7.99983,0,1,0-11.3125,11.31445,63.99908,63.99908,0,0,1,0,90.50879A7.99983,7.99983,0,1,0,224.544,184.58a79.99795,79.99795,0,0,0,0-113.13769Z" />
        <path d="M191.97656,128.01169a23.83779,23.83779,0,0,1-7.02929,16.96972,7.99984,7.99984,0,1,0,11.3125,11.31446,39.99957,39.99957,0,0,0,.001-56.56934A8.00052,8.00052,0,0,0,184.94629,111.041,23.84269,23.84269,0,0,1,191.97656,128.01169Z" />
        <path d="M53.91992,34.61813A8.0006,8.0006,0,1,0,42.08008,45.3818L73.56152,80.01169H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224.01169v-48.918l42.08008,46.28808a8.0006,8.0006,0,1,0,11.83984-10.76367ZM32,96.01169H71.99414v64H32ZM144,207.65426,87.99414,164.09518v-68.208L144,157.49362Z" />
        <path d="M117.06738,69.3154,144,48.36911v58.46a8,8,0,0,0,16,0V32.01169a7.99958,7.99958,0,0,0-12.91113-6.31446L107.24512,56.68649a7.99947,7.99947,0,0,0,9.82226,12.62891Z" />
      </g>,
    ],
  });
  return <CustomIcon size={6} />;
};
